"use client"

import { Merge } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MergeIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MergeIcon = component(Icon)({ as: Merge })
